module.exports = __webpack_public_path__ + "static/media/logout.72b0cffd.svg";